<template>
<el-drawer title="添加/编辑利润表" :visible.sync="drawer" :with-header="true" :append-to-body="true" @close="closeDrawer">
  <div class="drawer-form">
    <el-form ref="profitForm" :rules="rules" :model="ruleForm" label-position="top" :inline="true">
      <el-form-item label="收入总额" prop="income_fee">
        <el-input v-model="ruleForm.income_fee" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="应付酒店" prop="pay_hotel_fee">
        <el-input v-model="ruleForm.pay_hotel_fee" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="平台渠道费用" prop="source_fee">
        <el-input v-model="ruleForm.source_fee" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="个人渠道费用" prop="person_source_fee">
        <el-input v-model="ruleForm.person_source_fee" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="酒水成本" prop="wine_cost">
        <el-input v-model="ruleForm.wine_cost" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="赠送成本" prop="free_cost">
        <el-input v-model="ruleForm.free_cost" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="婚庆签单额" prop="wedding_cost">
        <el-input v-model="ruleForm.wedding_cost" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item label="婚宴净利" prop="banquet_profit">
        <el-input v-model="ruleForm.banquet_profit" @input="profitChange"></el-input>
      </el-form-item>
      <el-form-item class="remark" label="备注" size="medium">
        <el-input v-model="ruleForm.banquet_profit_remark"></el-input>
      </el-form-item>
      <div class="reminder">
        <p class="title"> <span>*</span> 提示</p>
        <div class="rules">婚宴净利 = 收入总额 - 应付酒店 - 平台渠道费用 - 个人渠道费用 - 酒水成本 - 赠送成本 - 婚庆签单额</div>
      </div>
      <el-form-item class="el-form-item-buttons">
        <el-button type="primary" @click="onSubmit('profitForm')">确定并更新</el-button>
        <el-button @click="resetForm('profitForm')">取消</el-button>
      </el-form-item>
    </el-form>
    <!-- 老版审核流程 -->
    <!-- <template v-if="process.length > 0">
            <auditProcess v-if="type != '2'" :process="process"></auditProcess>
        </template>    -->
    <!-- 新版审核流程  -->
    <template v-if="confirmStep.length > 0">
      <steps-look v-if="type != '2'" :stepList="confirmStep"></steps-look>
    </template>
  </div>
</el-drawer>
</template>

<script>
import auditProcess from '../../profit/components/auditProcess.vue';
// 新版审核流程
import StepsLook from '@/components/steps-look/steps-look';
export default {
  components: {
    auditProcess,
    StepsLook,
  },
  props: {
    order: ''
  },
  data() {
    return {
      drawer: false,
      ruleForm: {
        source_fee: '',
        source_fee_remark: '',
        person_source_fee: '',
        person_source_fee_remark: '',
        wine_cost: '',
        wine_cost_remark: '',
        wedding_cost: '',
        wedding_cost_remark: '',
        banquet_profit: '',
        banquet_profit_remark: '',
        free_cost: '',
        free_cost_remark: '',
        pay_hotel_fee: '',
        pay_hotel_fee_remark: '',
        income_fee: '',
        income_fee_remark: ''
      },
      rules: {
        source_fee: [{
          required: true
        }],
        person_source_fee: [{
          required: true
        }],
        wine_cost: [{
          required: true
        }],
        wedding_cost: [{
          required: true
        }],
        banquet_profit: [{
          required: true
        }],
        free_cost: [{
          required: true
        }],
        pay_hotel_fee: [{
          required: true
        }],
        income_fee: [{
          required: true
        }]
      },
      type: '',
      process: [],
      order_id: '',
      confirmStep: []
    };
  },
  methods: {
    showDrawers(type) {
      this.drawer = true;
      this.type = type;
      this.order_id = this.order.id;
      this.getConfirmProcess();
    },
    showDrawer(options, type) {
      this.drawer = true;
      this.type = type;
      this.ruleForm = options;
      this.order_id = options.order_id;
      this.getConfirmProcess();
    },
    // 利润发生变化
    profitChange() {
      let that = this;
      let income_fee = that.ruleForm.income_fee > 0 ? parseFloat(that.ruleForm.income_fee) : 0;
      let pay_hotel_fee = that.ruleForm.pay_hotel_fee > 0 ? parseFloat(that.ruleForm.pay_hotel_fee) : 0;
      let source_fee = that.ruleForm.source_fee > 0 ? parseFloat(that.ruleForm.source_fee) : 0;
      let person_source_fee = that.ruleForm.person_source_fee > 0 ? parseFloat(that.ruleForm.person_source_fee) : 0;
      let wine_cost = that.ruleForm.wine_cost > 0 ? parseFloat(that.ruleForm.wine_cost) : 0;
      let free_cost = that.ruleForm.free_cost > 0 ? parseFloat(that.ruleForm.free_cost) : 0;
      let wedding_cost = that.ruleForm.wedding_cost > 0 ? parseFloat(that.ruleForm.wedding_cost) : 0;
      that.ruleForm.banquet_profit = (
        income_fee -
        pay_hotel_fee -
        source_fee -
        person_source_fee -
        wine_cost -
        free_cost -
        wedding_cost
      ).toFixed(2);
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == '1') {
            //添加
            // /api/order.profit/doCreate
            let url = '/api/audit.profit/create';
            let query = {
              order_id: this.order.id,
              orderProfit: this.ruleForm
            };
            this.$post(url, query).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: '添加成功！！！',
                  type: 'success'
                });
                this.drawer = false;
                this.$parent.showOrder({
                  id: this.order.id
                });
                this.$emit('isShowFn', false);
              } else {
                this.$message.error(res.msg);
              }
            });
          } else if (this.type == '2') {
            let url = '/api/order.profit/save';
            let query = this.ruleForm;
            this.$post(url, query).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: '编辑成功！！！',
                  type: 'success'
                });
                this.drawer = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          } else if (this.type == '3') {
            // 审核驳回后 且是本人
            let url = '/api/audit.profit/edit';
            let query = {
              order_id: this.order.id,
              orderProfit: this.ruleForm
            };
            this.$post(url, query).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: '提交成功！！！',
                  type: 'success'
                });
                this.drawer = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.drawer = false;
    },
    getprocess() {
      let url = '/api/order.profit/create';
      let query = {
        order_id: this.order_id
      };
      this.$post(url, query).then((res) => {
        if (res.code == 200) {
          this.process = res.data.confirmList;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取审核流程
    getConfirmProcess() {
      let that = this;
      let url = '/api/order.audit/getAuditProcess';
      let params = {
        order_id: that.order_id,
        audit_type: 'order_profit',
        company_id: 0
      };
      that.$post(url, params).then(res => {
        if (res.code == 200) {
          that.confirmStep = res.data.process;
        } else {
          that.$message.warning(res.msg);
        }
      });
    },
    // 遮罩关闭  重置输入框内容
    closeDrawer() {
      // 添加
      if (this.type == '1') {
        this.ruleForm.income_fee = '';
        this.ruleForm.pay_hotel_fee = '';
        this.ruleForm.source_fee = '';
        this.ruleForm.person_source_fee = '';
        this.ruleForm.wine_cost = '';
        this.ruleForm.free_cost = '';
        this.ruleForm.wedding_cost = '';
        this.ruleForm.banquet_profit = '';
        this.ruleForm.banquet_profit_remark = ''
      }

    }
  }
};
</script>

<style lang="less">
.reminder {
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    color: #606266;

    span {
      color: red;
    }
  }

  .rules {
    font-size: 13px;
    padding-left: 14px;
    box-sizing: border-box;
    color: #606266;
  }
}

.remark {
  width: 100%;
  padding-left: 6px;
  box-sizing: border-box;
}

@import url('@/assets/css/drawer.less');
</style>
